import { MAKE_VARIANT_CAPABILITIES, type MakeVariant } from '@/constant/makeWorksheet/variant'

const PARAM = 'makeVariant'

export const getMakeVariant = (search: string): MakeVariant => {
  const value = new URLSearchParams(search).get(PARAM)
  // `in` 연산자는 프로토타입 키(toString 등)도 통과시키므로 own-key 검사 필수
  return value && Object.hasOwn(MAKE_VARIANT_CAPABILITIES, value)
    ? (value as MakeVariant)
    : 'default'
}

export const getMakeVariantCapabilities = (search: string) =>
  MAKE_VARIANT_CAPABILITIES[getMakeVariant(search)]

/**
 * query를 내장한 문자열 push(`${filterId}?${query}`)는 object form push의 search와 합칠 수 없다
 * — pathname 안의 `?`는 파싱되지 않아 filterId에 query가 섞여 들어간다. 그래서 문자열 뒤에
 * 이어 붙일 suffix 형태로만 제공한다 (default 모드는 빈 문자열).
 */
export const makeVariantSuffix = (search: string): string =>
  makeVariantSuffixFor(getMakeVariant(search))

export const makeVariantSuffixFor = (variant: MakeVariant): string =>
  variant === 'default' ? '' : `&${PARAM}=${variant}`

/** variant를 단독 search로 표현한다. query 뒤에 붙이는 makeVariantSuffix(`&`)와 달리 `?`로 시작한다 (default는 빈 문자열). */
export const makeVariantSearch = (variant: MakeVariant): string =>
  variant === 'default' ? '' : `?${PARAM}=${variant}`
